/**
 * De winkelwagen-URL mét taalprefix. Op /en/ en /fr/ is dat /en/cart en /fr/cart.
 * theme.liquid vult window.routes; de terugval is er voor als dat blok ooit
 * later laadt. Hardgecodeerd '/cart' gooide de bezoeker terug naar het
 * Nederlands, ook als hij van een /en/-productpagina kwam.
 */
function nlfCartUrl() {
  return (window.routes && window.routes.cart_url) || '/cart';
}

/* ============================================================
   NeverLeafs Bundel Builder, JS
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('nlb-root');
  if (!root) return;

  /* --- Config from data attributes --- */
  var tierMins = (root.dataset.tierMins || '2,4,8').split(',').map(Number);
  var tierPcts = (root.dataset.tierPcts || '5,10,15').split(',').map(Number);
  var tierCodes = (root.dataset.tierCodes || 'discount5,discount10,discount15').split(',');
  var freeShipThreshold = 7500; // cents

  var tiers = tierMins.map(function (min, i) {
    var max = tierMins[i + 1] ? tierMins[i + 1] - 1 : 999;
    return { min: min, max: max, pct: tierPcts[i], code: tierCodes[i] };
  });

  /* --- State --- */
  var bundle = {};  // { variantId: { qty, title, price, image, url } }
  var prevDiscPct = 0;

  /* --- Helpers --- */
  function fmt(cents) {
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getTotalItems() {
    var t = 0;
    for (var k in bundle) t += bundle[k].qty;
    return t;
  }

  function getSubtotal() {
    var s = 0;
    for (var k in bundle) s += bundle[k].price * bundle[k].qty;
    return s;
  }

  function getCurrentTier(totalItems) {
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (totalItems >= tiers[i].min) return tiers[i];
    }
    return null;
  }

  function getNextTier(totalItems) {
    for (var i = 0; i < tiers.length; i++) {
      if (totalItems < tiers[i].min) return tiers[i];
    }
    return null;
  }

  /* --- Animated counter --- */
  function animateValue(el, from, to, duration) {
    if (from === to) { el.textContent = fmt(to); return; }
    var start = performance.now();
    function step(now) {
      var progress = Math.min((now - start) / duration, 1);
      var val = Math.round(from + (to - from) * progress);
      el.textContent = fmt(val);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* --- Confetti --- */
  function fireConfetti() {
    var container = document.getElementById('nlb-confetti');
    if (!container) return;
    var colors = ['#E8720C', '#5a6b4a', '#F59E0B', '#b5c7a3', '#2D3B2D', '#E91E8C'];
    for (var i = 0; i < 40; i++) {
      var piece = document.createElement('div');
      piece.className = 'nlb-confetti__piece';
      var x = 30 + Math.random() * 40;
      var size = 6 + Math.random() * 8;
      var color = colors[Math.floor(Math.random() * colors.length)];
      var dur = (1.5 + Math.random()).toFixed(2);
      var delay = (Math.random() * 0.3).toFixed(2);
      var rot = Math.floor(Math.random() * 360);
      piece.style.cssText = 'left:' + x + '%;top:-5%;width:' + size + 'px;height:' + (size * 0.6) + 'px;background:' + color + ';transform:rotate(' + rot + 'deg);--nlb-cf-dur:' + dur + 's;--nlb-cf-delay:' + delay + 's;';
      container.appendChild(piece);
      // Force reflow then add class
      piece.offsetHeight;
      piece.classList.add('is-active');
    }
    setTimeout(function () { container.innerHTML = ''; }, 3000);
  }

  /* --- Core actions --- */
  function addToBundle(variantId) {
    var card = document.querySelector('.nlb-card[data-variant-id="' + variantId + '"]');
    if (!card) return;
    if (bundle[variantId]) {
      bundle[variantId].qty++;
    } else {
      bundle[variantId] = {
        qty: 1,
        title: card.dataset.title,
        price: parseInt(card.dataset.price, 10),
        image: card.dataset.image,
        url: card.dataset.url
      };
    }
    updateUI();
  }

  function removeFromBundle(variantId) {
    if (!bundle[variantId]) return;
    if (bundle[variantId].qty > 1) {
      bundle[variantId].qty--;
    } else {
      delete bundle[variantId];
    }
    updateUI();
  }

  /* --- Update UI --- */
  function updateUI() {
    var totalItems = getTotalItems();
    var subtotal = getSubtotal();
    var tier = getCurrentTier(totalItems);
    var discPct = tier ? tier.pct : 0;
    var discount = Math.round(subtotal * discPct / 100);
    var total = subtotal - discount;
    var nextTier = getNextTier(totalItems);

    // Confetti on tier unlock
    if (discPct > prevDiscPct && discPct > 0) {
      fireConfetti();
    }
    prevDiscPct = discPct;

    updateTierBar(totalItems, discPct);
    updateProgressBar(totalItems, nextTier);
    updateCards(discPct);
    updateSidebar(totalItems, subtotal, discPct, discount, total, nextTier);
    updateMobileBar(totalItems, total);
    updateSavingsBadge(discount);
  }

  function updateTierBar(totalItems, discPct) {
    var tierEls = document.querySelectorAll('.nlb-tier');
    tierEls.forEach(function (el, i) {
      var t = tiers[i];
      var isActive = discPct === t.pct && totalItems >= t.min;
      var isPast = discPct > t.pct;
      el.classList.toggle('is-active', isActive);
      el.classList.toggle('is-past', isPast);
      if (isActive && !el.classList.contains('was-active')) {
        el.classList.add('is-unlocked');
        setTimeout(function () { el.classList.remove('is-unlocked'); }, 500);
      }
      el.classList.toggle('was-active', isActive);
    });
  }

  function updateProgressBar(totalItems, nextTier) {
    var progress = document.querySelector('.nlb-progress');
    var fill = document.querySelector('.nlb-progress__fill');
    var text = document.querySelector('.nlb-progress__text');
    if (!progress) return;

    if (nextTier && totalItems > 0) {
      progress.classList.add('is-visible');
      var pct = Math.min((totalItems / nextTier.min) * 100, 100);
      fill.style.width = pct + '%';
      text.textContent = 'Nog ' + (nextTier.min - totalItems) + ' voor ' + nextTier.pct + '%';
    } else if (totalItems >= tiers[tiers.length - 1].min) {
      progress.classList.add('is-visible');
      fill.style.width = '100%';
      text.textContent = 'Maximum korting bereikt';
    } else {
      progress.classList.remove('is-visible');
      fill.style.width = '0%';
    }
  }

  function updateCards(discPct) {
    document.querySelectorAll('.nlb-card').forEach(function (card) {
      var vid = card.dataset.variantId;
      var item = bundle[vid];
      var qty = item ? item.qty : 0;
      var isSelected = qty > 0;

      card.classList.toggle('is-selected', isSelected);

      // Qty badge
      var badge = card.querySelector('.nlb-card__qty-badge');
      if (badge) badge.textContent = qty + '\u00D7';

      // Qty value
      var qtyVal = card.querySelector('.nlb-card__qty-val');
      if (qtyVal) qtyVal.textContent = qty;

      // Discount price
      var discEl = card.querySelector('.nlb-card__disc-price');
      if (discEl) {
        if (discPct > 0) {
          var price = parseInt(card.dataset.price, 10);
          discEl.textContent = '\u2192 ' + fmt(Math.round(price * (1 - discPct / 100)));
          discEl.classList.add('is-visible');
        } else {
          discEl.classList.remove('is-visible');
        }
      }
    });
  }

  function updateSidebar(totalItems, subtotal, discPct, discount, total, nextTier) {
    // Meta text
    var meta = document.querySelector('.nlb-sidebar__meta');
    if (meta) {
      meta.textContent = totalItems === 0
        ? 'Selecteer planten hiernaast'
        : totalItems + ' ' + (totalItems === 1 ? 'plant' : 'planten') + ' \u00B7 ' + discPct + '% korting';
    }

    // Discount badge in header
    var discBadge = document.querySelector('.nlb-sidebar__disc-badge');
    if (discBadge) {
      discBadge.textContent = '-' + discPct + '%';
      discBadge.classList.toggle('is-visible', discPct > 0);
    }

    // Thumbnail stack
    var thumbsWrap = document.querySelector('.nlb-sidebar__thumbs');
    var thumbsRow = document.querySelector('.nlb-sidebar__thumbs-row');
    var thumbsText = document.querySelector('.nlb-sidebar__thumbs-text');
    if (thumbsWrap && thumbsRow) {
      var keys = Object.keys(bundle);
      thumbsWrap.classList.toggle('is-visible', keys.length > 0);
      thumbsRow.innerHTML = '';
      var shown = keys.slice(0, 5);
      shown.forEach(function (vid) {
        var div = document.createElement('div');
        div.className = 'nlb-sidebar__thumb';
        div.innerHTML = '<img src="' + bundle[vid].image + '" alt="" loading="lazy">';
        thumbsRow.appendChild(div);
      });
      if (keys.length > 5) {
        var extra = document.createElement('div');
        extra.className = 'nlb-sidebar__thumb nlb-sidebar__thumb--extra';
        extra.textContent = '+' + (keys.length - 5);
        thumbsRow.appendChild(extra);
      }
      if (thumbsText) thumbsText.textContent = totalItems + ' planten in je bundel';
    }

    // Empty state vs items
    var emptyEl = document.querySelector('.nlb-sidebar__empty');
    var itemsEl = document.querySelector('.nlb-sidebar__items');
    var pricingEl = document.querySelector('.nlb-sidebar__pricing');

    if (totalItems === 0) {
      if (emptyEl) emptyEl.style.display = '';
      if (itemsEl) itemsEl.classList.remove('is-visible');
      if (pricingEl) pricingEl.classList.remove('is-visible');
    } else {
      if (emptyEl) emptyEl.style.display = 'none';
      if (itemsEl) {
        itemsEl.classList.add('is-visible');
        renderSidebarItems(itemsEl);
      }
      if (pricingEl) {
        pricingEl.classList.add('is-visible');
        updatePricing(subtotal, discPct, discount, total);
      }
    }

    // CTA
    var cta = document.querySelector('.nlb-sidebar__cta');
    if (cta) {
      cta.classList.toggle('is-active', totalItems >= 2);
      var ctaText = cta.querySelector('.nlb-sidebar__cta-text');
      if (ctaText) {
        ctaText.textContent = totalItems < 2
          ? 'Nog ' + (2 - totalItems) + ' plant' + ((2 - totalItems) > 1 ? 'en' : '') + ' nodig'
          : 'Bundel in winkelwagen';
      }
      var ctaIcon = cta.querySelector('.nlb-sidebar__cta-icon');
      if (ctaIcon) ctaIcon.style.display = totalItems >= 2 ? '' : 'none';
    }

    // Free shipping
    var shippingEl = document.querySelector('.nlb-sidebar__shipping');
    if (shippingEl) {
      shippingEl.classList.toggle('is-visible', totalItems > 0);
      var freeEl = shippingEl.querySelector('.nlb-sidebar__shipping-text');
      var remainEl = shippingEl.querySelector('.nlb-sidebar__shipping-text--remaining');
      if (freeEl) { freeEl.style.display = ''; freeEl.textContent = 'Voor 16:00 besteld, morgen in huis'; }
      if (remainEl) remainEl.style.display = 'none';
    }
  }

  function renderSidebarItems(container) {
    container.innerHTML = '';
    for (var vid in bundle) {
      var item = bundle[vid];
      var div = document.createElement('div');
      div.className = 'nlb-sidebar__item';
      div.innerHTML =
        '<div class="nlb-sidebar__item-img"><img src="' + item.image + '" alt="" loading="lazy"></div>' +
        '<div class="nlb-sidebar__item-info">' +
          '<div class="nlb-sidebar__item-name">' + item.title + '</div>' +
          '<div class="nlb-sidebar__item-detail">' + item.qty + '\u00D7 ' + fmt(item.price) + '</div>' +
        '</div>' +
        '<div class="nlb-sidebar__item-btns">' +
          '<button class="nlb-sidebar__item-btn" data-action="remove" data-vid="' + vid + '" aria-label="Verwijder">' +
            '<svg viewBox="0 0 24 24"><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
          '</button>' +
          '<button class="nlb-sidebar__item-btn" data-action="add" data-vid="' + vid + '" aria-label="Voeg toe">' +
            '<svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
          '</button>' +
        '</div>';
      container.appendChild(div);
    }
  }

  var prevSubtotal = 0;
  var prevDiscount = 0;
  var prevTotal = 0;

  function updatePricing(subtotal, discPct, discount, total) {
    var subEl = document.querySelector('.nlb-sidebar__subtotal-value');
    if (subEl) { animateValue(subEl, prevSubtotal, subtotal, 300); }

    var discRow = document.querySelector('.nlb-sidebar__discount-row');
    var discLabel = document.querySelector('.nlb-sidebar__discount-label');
    var discValue = document.querySelector('.nlb-sidebar__discount-value');
    if (discRow) {
      discRow.classList.toggle('is-visible', discPct > 0);
      if (discLabel) discLabel.textContent = 'Bundelkorting ' + discPct + '%';
      if (discValue) animateValue(discValue, prevDiscount, discount, 300);
    }

    var totalEl = document.querySelector('.nlb-sidebar__total-amount');
    if (totalEl) {
      animateValue(totalEl, prevTotal, total, 300);
      totalEl.classList.toggle('has-discount', discPct > 0);
    }

    var savedEl = document.querySelector('.nlb-sidebar__total-saved');
    if (savedEl) {
      savedEl.classList.toggle('is-visible', discPct > 0);
      if (discPct > 0) savedEl.textContent = 'Je bespaart ' + fmt(discount);
    }

    prevSubtotal = subtotal;
    prevDiscount = discount;
    prevTotal = total;
  }

  function updateMobileBar(totalItems, total) {
    var bar = document.querySelector('.nlb-mobile-bar');
    if (!bar) return;
    var info = bar.querySelector('.nlb-mobile-bar__info');
    var totalEl = bar.querySelector('.nlb-mobile-bar__total');
    var btn = bar.querySelector('.nlb-mobile-bar__btn');

    if (info) info.textContent = totalItems + ' ' + (totalItems === 1 ? 'plant' : 'planten');
    if (totalEl) totalEl.textContent = fmt(total);
    if (btn) {
      btn.classList.toggle('is-active', totalItems >= 2);
      btn.textContent = totalItems >= 2 ? 'Bekijk bundel' : 'Nog ' + (2 - totalItems) + ' nodig';
    }
  }

  function updateSavingsBadge(discount) {
    var badge = document.querySelector('.nlb-hero__savings');
    var val = document.querySelector('.nlb-hero__savings-value');
    if (badge) badge.classList.toggle('is-visible', discount > 0);
    if (val && discount > 0) val.textContent = fmt(discount);
  }

  /* --- Add bundle to cart --- */
  function addBundleToCart() {
    var totalItems = getTotalItems();
    if (totalItems < 2) return;

    var tier = getCurrentTier(totalItems);
    var items = [];
    for (var vid in bundle) {
      items.push({
        id: parseInt(vid, 10),
        quantity: bundle[vid].qty,
        properties: { _bundle: 'bundelvoordeel' }
      });
    }

    var cta = document.querySelector('.nlb-sidebar__cta');
    if (cta) cta.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart error');
      return res.json();
    })
    .then(function () {
      var discountCode = tier ? tier.code : '';
      if (discountCode) {
        window.location.href = '/discount/' + discountCode + '?redirect=' + nlfCartUrl();
      } else {
        window.location.href = nlfCartUrl();
      }
    })
    .catch(function (err) {
      console.error('Bundle cart error:', err);
      if (cta) cta.classList.remove('is-loading');
      alert('Er ging iets mis. Probeer het opnieuw.');
    });
  }

  /* --- Mini gallery --- */
  function handleGallery(card, direction) {
    var imgEl = card.querySelector('.nlb-card__img');
    if (!imgEl) return;
    var images;
    try { images = JSON.parse(card.dataset.images); } catch (e) { return; }
    if (!images || images.length < 2) return;

    var current = parseInt(card.dataset.currentImg || '0', 10);
    if (direction === 'next') {
      current = (current + 1) % images.length;
    } else if (direction === 'prev') {
      current = (current - 1 + images.length) % images.length;
    } else {
      current = direction; // dot index
    }
    card.dataset.currentImg = current;
    imgEl.src = images[current];

    // Update dots
    card.querySelectorAll('.nlb-card__dot').forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === current);
    });
  }

  /* --- Category filter --- */
  function filterByCategory(cat) {
    document.querySelectorAll('.nlb-filter-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.category === cat);
    });
    document.querySelectorAll('.nlb-card').forEach(function (card) {
      if (cat === 'Alle' || card.dataset.category === cat) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  }

  /* --- Mobile sheet --- */
  function openSheet() {
    var sheet = document.querySelector('.nlb-sheet');
    var backdrop = document.querySelector('.nlb-sheet-backdrop');
    if (sheet) {
      sheet.style.display = 'block';
      // Force reflow for transition
      sheet.offsetHeight;
      sheet.classList.add('is-open');
    }
    if (backdrop) backdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden';

    // Render sheet items
    var sheetItems = document.querySelector('.nlb-sheet__items');
    if (sheetItems) renderSidebarItems(sheetItems);
    updateSheetPricing();
  }

  function closeSheet() {
    var sheet = document.querySelector('.nlb-sheet');
    var backdrop = document.querySelector('.nlb-sheet-backdrop');
    if (sheet) sheet.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (sheet) sheet.style.display = '';
    }, 300);
  }

  function updateSheetPricing() {
    var totalItems = getTotalItems();
    var subtotal = getSubtotal();
    var tier = getCurrentTier(totalItems);
    var discPct = tier ? tier.pct : 0;
    var discount = Math.round(subtotal * discPct / 100);
    var total = subtotal - discount;

    var subEl = document.querySelector('.nlb-sheet__subtotal');
    if (subEl) subEl.textContent = fmt(subtotal);

    var discRow = document.querySelector('.nlb-sheet__discount-row');
    if (discRow) {
      discRow.style.display = discPct > 0 ? 'flex' : 'none';
      var discLabel = discRow.querySelector('.nlb-sheet__discount-label');
      if (discLabel) discLabel.textContent = 'Bundelkorting ' + discPct + '%';
      var discVal = discRow.querySelector('.nlb-sheet__discount-value');
      if (discVal) discVal.textContent = '\u2212' + fmt(discount);
    }

    var totalEl = document.querySelector('.nlb-sheet__total');
    if (totalEl) totalEl.textContent = fmt(total);

    var ctaSheet = document.querySelector('.nlb-sheet__cta');
    if (ctaSheet) {
      ctaSheet.classList.toggle('is-active', totalItems >= 2);
      var ctaText = ctaSheet.querySelector('.nlb-sheet__cta-text');
      if (ctaText) ctaText.textContent = totalItems >= 2 ? 'Bundel in winkelwagen' : 'Nog ' + (2 - totalItems) + ' nodig';
    }
  }

  /* --- Event delegation --- */
  root.addEventListener('click', function (e) {
    var target = e.target.closest('[data-action]');
    if (!target) {
      // Check other click targets
      var filterBtn = e.target.closest('.nlb-filter-btn');
      if (filterBtn) {
        filterByCategory(filterBtn.dataset.category);
        return;
      }

      var arrow = e.target.closest('.nlb-card__arrow');
      if (arrow) {
        e.stopPropagation();
        var card = arrow.closest('.nlb-card');
        handleGallery(card, arrow.classList.contains('nlb-card__arrow--next') ? 'next' : 'prev');
        return;
      }

      var dot = e.target.closest('.nlb-card__dot');
      if (dot) {
        e.stopPropagation();
        var dotCard = dot.closest('.nlb-card');
        var dotIndex = Array.from(dot.parentElement.children).indexOf(dot);
        handleGallery(dotCard, dotIndex);
        return;
      }

      var mobileBtnEl = e.target.closest('.nlb-mobile-bar__btn');
      if (mobileBtnEl && mobileBtnEl.classList.contains('is-active')) {
        openSheet();
        return;
      }

      var backdropEl = e.target.closest('.nlb-sheet-backdrop');
      if (backdropEl) {
        closeSheet();
        return;
      }

      var handleEl = e.target.closest('.nlb-sheet__handle');
      if (handleEl) {
        closeSheet();
        return;
      }

      return;
    }

    var action = target.dataset.action;
    var vid = target.dataset.vid;

    if (action === 'add' && vid) {
      addToBundle(vid);
      // Also update sheet if open
      var sheetEl = document.querySelector('.nlb-sheet');
      if (sheetEl && sheetEl.classList.contains('is-open')) {
        var sheetItems = document.querySelector('.nlb-sheet__items');
        if (sheetItems) renderSidebarItems(sheetItems);
        updateSheetPricing();
      }
    } else if (action === 'remove' && vid) {
      removeFromBundle(vid);
      var sheetEl2 = document.querySelector('.nlb-sheet');
      if (sheetEl2 && sheetEl2.classList.contains('is-open')) {
        var sheetItems2 = document.querySelector('.nlb-sheet__items');
        if (sheetItems2) renderSidebarItems(sheetItems2);
        updateSheetPricing();
      }
    } else if (action === 'add-to-cart') {
      addBundleToCart();
    }
  });

  // Initialize: set first dot as active
  document.querySelectorAll('.nlb-card').forEach(function (card) {
    var firstDot = card.querySelector('.nlb-card__dot');
    if (firstDot) firstDot.classList.add('is-active');
  });

})();
